import { render, staticRenderFns } from "./header-notifications.vue?vue&type=template&id=a599b31a"
import script from "./header-notifications.vue?vue&type=script&lang=js"
export * from "./header-notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a599b31a')) {
      api.createRecord('a599b31a', component.options)
    } else {
      api.reload('a599b31a', component.options)
    }
    module.hot.accept("./header-notifications.vue?vue&type=template&id=a599b31a", function () {
      api.rerender('a599b31a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/header-notifications.vue"
export default component.exports